<template>
  <transition name="el-zoom-in-top">
    <div class="content-wrapper">
      <!-- Main content -->
      <section class="content">
        <div class="box citic-box">
          <el-tabs
            v-model="activeName"
            @tab-click="handleClick"
          >
            <el-tab-pane
              label="类别标签管理"
              name="0"
            >
              <div>
                <el-autocomplete
                  class="search"
                  v-model.trim="keywords"
                  :fetch-suggestions="querySearch"
                  placeholder="按类别搜"
                  @select="handleSelect"
                  type="text"
                ></el-autocomplete>
                <el-button
                  @click="onSearch"
                  class="btn-search"
                  type="primary"
                >搜索</el-button>
                <el-button
                  @click="onDelete"
                  class="btn-search"
                  type="danger"
                >删除</el-button>
              </div>
              <el-button
                type="primary"
                @click="handleEdit()"
              >增加新类别</el-button>
              <el-table
                ref="mytable"
                :data="labelList"
                style="width:100%; margin:20px 0 20px 0 ;"
                border
                fit
              >
                <el-table-column
                  prop="CNAME"
                  label="类别名称"
                >
                  <!-- <el-tag v-for="tag in CNAME"
                      :key="tag">
                      {{tag}}
                  </el-tag> -->
                </el-table-column>
                <el-table-column
                  prop="NAVIGATION_ID"
                  label="所属大类"
                >
                </el-table-column>
                <el-table-column
                  prop="title"
                  label="功能清单"
                >
                  <template slot-scope="scope">
                    <el-button
                      type="primary"
                      @click="funcList(scope.row.CID)"
                    >
                      功能清单
                    </el-button>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="CMARK"
                  label="点评量"
                >
                </el-table-column>
                <el-table-column
                  prop="isrecommend"
                  label="拉动点评"
                >
                <template slot-scope="scope">
                  <el-button
                    type="success"
                    v-if="scope.row.isrecommend === '1' "
                    @click="comment(scope.row)"
                  >
                    发起“点评抢钱”
                  </el-button>
                  <el-button
                    type="primary"
                    v-else
                    @click="comment(scope.row)"
                  >
                    发起“点评抢钱”
                  </el-button>
                </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button
                      @click="handleEdit(scope.row.CID)"
                      type="primary"
                      size="small"
                      v-if="!scope.row.isSet"
                    >编辑</el-button>
                    <!-- <el-button
                      @click="handleSave(scope.$index,scope.row)"
                      type="primary"
                      size="small"
                      v-if="scope.row.isSet"
                    >保存</el-button> -->
                    <el-button
                      @click="handleDelete(scope.row)"
                      type="danger"
                      size="small"
                    >删除</el-button>
                  </template>

                </el-table-column>
              </el-table>
              <!-- 分页 -->
              <div class="table-list__footer">
                <el-pagination
                  @current-change="handlePageChangeOne"
                  :current-page="currentPage"
                  :page-size="page_size"
                  layout="total, prev, pager, next, jumper"
                  :total="totalOne"
                >
                </el-pagination>
              </div>
            </el-tab-pane>
            <el-tab-pane
              label="大类管理"
              name="1"
            >
              <el-card class="box-card">
                <div
                  slot="header"
                  class="clearfix"
                  style="height:30px"
                >
                  <p class="key-title">已录入的维度</p>
                </div>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-input
                      class="input-new-tag"
                      v-model="inputValue"
                      ref="saveTagInput"
                      size="small"
                      @keyup.enter.native="handleInputConfirm"
                      @blur="handleInputConfirm"
                      placeholder="录入新的维度分类"
                      style="width:300px"
                    >
                    </el-input>
                  </el-col>
                  <el-col :span="4">
                    <el-button
                      class="button-new-tag"
                      type="primary"
                      @click="addItem"
                      size="small"
                      style="margin-bottom:20px"
                    >添加</el-button>
                  </el-col>
                </el-row>
                <div
                  v-for="tag in classList"
                  :key="tag.ID"
                  class="text item"
                  style="margin-top: 20px"
                >
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <p class="keys">
                        <el-tag type="success">{{tag.NAME}}</el-tag>
                      </p>
                    </el-col>
                    <el-col :span="6">
                      <el-button
                        @click="handleClass(tag.ID)"
                        type="danger"
                        size="small"
                      >删除</el-button>
                    </el-col>
                  </el-row>
                </div>
              </el-card>
            </el-tab-pane>
          </el-tabs>
        </div>

      </section>
      <!-- /.content -->
    </div>
  </transition>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    const item = {
      date: '2016-05-02',
      name: '王小虎',
      address: '上海市普陀区金沙江路 1518 弄'
    }
    return {
      dynamicTags: ['标签一', '标签二', '标签三'],
      inputValue: '',
      tableData: Array(20).fill(item),
      filterKeyWord: '',
      historyList: [], // 作为一个数据变量接收搜索历史记录
      activeName: '0',
      currentPage: 0,
      totalOne: 0,
      pageSize: 10,

      loading: false,
      timeoutKeyWord: null,
      classList: [],
      labelList: [],
      keywords: '',
      options: [
        {
          value: 0,
          label: '待推荐'
        },
        {
          value: 1,
          label: '推荐'
        }
      ],
      inputVisible: false
    }
  },
  methods: {
    // comment发起点评抢钱
    comment (scope) {
      console.log('scope.CID', scope.CID)
      let url = this.$config.API.reviews.commentMoney
      let data = {
        category_id: scope.CID
      }
      axios.post(url, data).then(res => {
        console.log(res)
        this.fetchData('0')
      })
    },
    // 功能清单弹窗
    funcList (id) {
      this.$forceUpdate()
      this.$router.push(`/funcList/new/${id}`)
    },
    // 删除table内容
    handleDelete (scope) {
      let url = this.$config.API.category.delDetial
      let data = {
        category_id: scope.CID
      }
      console.log('222', scope.qcname)
      axios.post(url, data).then(res => {
        this.$confirm('删除该厂商信息?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.fetchData()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }).catch(err => {
        this.loading = false
        this.$message.error('该厂商有关联账号，删除失败')
        console.log(err)
      })
    },
    // 删除tag标签
    handleClass (id) {
      let url = this.$config.API.class.del
      let data = {
        navigation_id: id
      }
      axios.post(url, data).then(res => {
        console.log(res)
      })
      this.classList.splice(id, 1)
    },
    // 显示tag标签
    addItem () {
      if (this.inputValue === '') {
        this.$message.error('请输入或选择类别后再添加')
        return false
      }
      let data = {
        navigation_name: inputValue
      }
      this.classList.unshift(data)
      this.inputValue = ''
    },
    // 确认输入tag标签
    handleInputConfirm () {
      let inputValue = this.inputValue
      let url = this.$config.API.class.add
      let data = {
        navigation_name: this.inputValue
      }
      axios.post(url, data).then(res => {
        console.log(res)
      })
      inputValue = {
        NAME: inputValue
      }

      if (inputValue) {
        this.classList.unshift(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    // 编辑修改内容
    handleEdit (id) {
      this.$forceUpdate()
      if (id) {
        this.$router.push(`/category/edit/${id}`)
      } else {
        this.$router.push(`/category/new`)
      }
    },
    // 类别搜索
    handleSelect (item) {
      console.log(item)
    },
    querySearch (keywords, cb) {
      // if (!keywords) return
      let url = this.$config.API.auto.category
      let data = {
        keywords: keywords
      }
      axios.post(url, data).then(res => {
        if (res.status === 200) {
          cb(res.data.result)
        }
      })
    },
    // 搜索回车/虚拟操作键盘搜索
    onSearch () {
      this.timeoutKeyWord = setTimeout(() => {
        this.fetchData('0')
      }, 500)
    },
    // 删除搜索内容
    onDelete () {
      this.keywords = ''
      this.fetchData()
    },
    // tab切换
    handleClick (tab, event) {
      this.fetchData(this.activeName)
      // console.log(tab, event, this.activeName)
    },
    // 获取列表数据
    fetchData (activeName) {
      this.loading = true
      let url = null
      if (this.activeName === '0') {
        url = this.$config.API.category.list
      } else {
        url = this.$config.API.class.list
      }
      let params = null
      if (this.activeName === '0') {
        params = {
          page: Number(this.currentPage),
          keywords: this.keywords
        }
      }
      axios.get(url, { params }).then(res => {
        if (this.activeName === '0') {
          this.labelList = res.data.categoryList
          this.totalOne = res.data.total
          this.loading = false
          console.log('222', res.data.categoryList)
        } else if (this.activeName === '1') {
          this.classList = res.data.navigationList
          this.loading = false
        }
      }).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    // 页面分页
    handlePageChangeOne (page) {
      this.currentPage = page
      this.fetchData('0')
    }
  },
  mounted () {
    this.fetchData(this.activeName)
  }
}
</script>
<style lang="scss">
.citic-box {
  padding-top: 15px;
  .el-tabs__content {
    overflow: visible !important;
    position: static;
  }
  .box-header {
    ul.nav-tabs {
      margin-bottom: 0 !important;
      border-bottom: 0;
      li > a {
        color: #9ebbcd !important;
      }
      li.active > a {
        color: #333 !important;
      }
    }
  }
  .search {
    width: 80%;
    margin-bottom: 20px;
  }
  .btn-search {
    margin-left: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// category.vue?f3aef4d2